"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ__IconContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ__IconContainer = (0, _styledComponents["default"])('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: var(--color-font-base);\n    box-sizing: border-box;\n    display: ", ";\n    align-items: center;\n    cursor: ", ";\n\n    color: ", ";\n"])), function (props) {
  if (props.isInline) {
    return 'inline-flex';
  } else {
    return 'flex';
  }
}, function (props) {
  return props.isClickable && 'pointer';
}, function (props) {
  if (props.color === 'highlight') {
    return 'var(--color-primary-highlight)';
  } else if (props.color === 'muted') {
    return 'var(--color-primary-muted)';
  } else if (props.color === 'primary') {
    return 'var(--color-primary)';
  } else if (props.color === 'secondary') {
    return 'var(--color-secondary)';
  } else if (props.color === 'white') {
    return 'var(--color-base-white)';
  } else if (props.color === 'warning') {
    return 'var(--color-orange-600)';
  } else if (props.color === 'error') {
    return 'var(--color-red-600)';
  }
});
exports.Occ__IconContainer = Occ__IconContainer;